import React from 'react';
import { Formik, Form } from 'formik';
import { DeactivateYourCompanySchema } from '../../../schemas';
import { PrimaryButton, ErrorButton } from "../../UI";
import { FormikInput } from '../Formik';
import { useContentfulContext } from '../../../contexts/ContentfulContext';

const DeactivateYourCompanyForm = ({ submitHandler, handleCancelClick }) => {
    const { content } = useContentfulContext();

    return (
        <Formik
            initialValues={{
                password: '',
            }}
            validationSchema={() => DeactivateYourCompanySchema(content.DEACTIVATE_YOUR_COMPANY)}
            onSubmit={async () => {
                submitHandler();
            }}
        >
            {() => (
                <Form className="space-y-4 md:space-y-6" action="#">
                    <FormikInput
                        type="password"
                        name="password"
                        id="password"
                        label={content.DEACTIVATE_YOUR_COMPANY.formLabels.password}
                        placeholder="••••••••"
                    />
                    <div className="mb-4 space-x-4 flex items-center">
                        <ErrorButton type="submit">{content.DEACTIVATE_YOUR_COMPANY.formLabels.cta_text}</ErrorButton>
                        <PrimaryButton handleClick={handleCancelClick}>{content.DEACTIVATE_YOUR_COMPANY.formLabels.cancel_text}</PrimaryButton>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default DeactivateYourCompanyForm;
